if (!customElements.get('ge-buy-shortcut')) {
  customElements.define('ge-buy-shortcut', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      const main = this.closest('product-info');
      const target = document.getElementById(this.dataset.target);
      const button = main?.querySelector('.product-form__submit');
      if (!main || !target || !button || !('IntersectionObserver' in window)) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      let mainVisible = false, buttonVisible = true;
      this.update = () => {
        const focused = document.activeElement;
        const typing = focused && /^(INPUT|TEXTAREA|SELECT)$/.test(focused.tagName);
        const modal = document.querySelector('dialog[open], quick-add-modal[open], .search-modal[open], details[open] .menu-drawer');
        this.hidden = !mainVisible || buttonVisible || typing || !!modal;
      };
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === main) mainVisible = entry.isIntersecting;
          if (entry.target === button) buttonVisible = entry.isIntersecting;
        }
        this.update();
      });
      this.observer.observe(main); this.observer.observe(button);
      document.addEventListener('focusin', this.update, options);
      document.addEventListener('focusout', () => queueMicrotask(this.update), options);
      this.querySelector('a').addEventListener('click', () => {
        target.focus({preventScroll:true});
      }, options);
    }
    cleanup() { this.observer?.disconnect(); this.abort?.abort(); }
    disconnectedCallback() { this.cleanup(); }
  });
}
if (!customElements.get('ge-article-nav')) {
  customElements.define('ge-article-nav', class extends HTMLElement {
    connectedCallback() {
      const article = this.closest('.article-template__content');
      const headings = [...(article?.querySelectorAll('h2,h3') || [])].filter(h => h.textContent.trim());
      const details = this.querySelector('details'), list = this.querySelector('ol');
      if (!details || !list) return;
      list.replaceChildren();
      if (headings.length < 2) { details.hidden = true; return; }
      headings.forEach((h, i) => {
        if (!h.id) {
          let id = `ge-guide-heading-${i+1}`;
          while (document.getElementById(id)) id += '-x';
          h.id = id;
        }
        const item = document.createElement('li'), link = document.createElement('a');
        link.setAttribute('href', '#' + encodeURIComponent(h.id));
        link.textContent = h.textContent.trim();
        item.append(link); list.append(item);
      });
      details.hidden = false;
    }
  });
}
